import { api } from "./connection/api";

const VEHICLES_ENDPOINT_PREFIX = "vehicles";

export const vehiclesApi = api.injectEndpoints({
    endpoints: builder => ({
        fetchVehicles: builder.mutation({
            query: ({ registrationNumber }) => {
                const formData = new FormData();
                formData.append("registrationNumber", registrationNumber);
                return {
                    url: `${VEHICLES_ENDPOINT_PREFIX}`,
                    method: "POST",
                    body: formData,
                };
            },
        }),
    }),
});

export const {
    useFetchVehiclesMutation,
} = vehiclesApi;
